module.exports = __webpack_public_path__ + "63d105c9bbdc86613d1f4e7ce379fd56.png";